<app-header></app-header>
<div class="Training">
  <div class="Training_data bg_2">
    <ng-container *ngFor="let heading of head">
      <div
        class="Training_data_top text-center p-top-220 bg_img"
        *ngIf="heading.page === currentPage"
      >
        
        <div class="inline_padding3"> 
          <span class="text_style_5"
            >Training Videos ChemRobotics®<sup class="text_blue_1">TM</sup>
          </span>
        </div>
        <div class="inline_padding3 p-top-16 bottom_padding1">
          <span
            class="text_style_1"
            [innerHTML]="heading.page_sub_heading"
          ></span>
        </div>
      </div>
    </ng-container>
    <div class="Training_data_bottom bg_2">
        <div class="Training_data_bottom_container">
            <div class="filter_training" id="trainingFilter">
                <div class="row mx-0">
                    <div class="col-12 col-md-6" style="display: flex; align-items: center;"><span style="font-size: 18px; font-weight: 600;margin-left: 20px;">Total: {{totalTrainingVideo}}</span></div>
                    <div class="col-12 col-md-6" style="display: flex; align-items: center;justify-content: flex-end;">  <p-multiSelect 
                        [options]="database" 
                        [(ngModel)]="selectedDatabase" 
                        optionLabel="name" 
                        placeholder="Select Database"
                        display="chip"
                        (onChange)="sortTrainingByDatabase()"
                        /></div>
                </div>
            </div>
            <ng-container *ngFor="let video of trainingvideoList; let i = index">
          <div class="dispaly_1">
            <div class="Training_data_bottom_container_inner">
              <div
                *ngIf="i % 2 === 0"
                class="Training_data_bottom_container_inner_box bg_1"
              >
                <div class="Training_data_bottom_container_inner_box_right">
                  <div
                    class="Training_data_bottom_container_inner_box_right_sec"
                  >
                    <div
                      class="Training_data_bottom_container_inner_box_right_sec_video border-radius-26"
                    >
                      <video
                        class="Training_data_bottom_container_inner_box_right_sec_video_link"
                        width="100%"
                        height="100%"
                        [id]="'video-' + i"
                        [poster]="videosThumbnailUrl + video.thumbnail"
                        [src]="videoBaseUrl + video.video"
                      >
                      </video>
                    </div>
                    <div
                      class="Training_data_bottom_container_inner_box_right_sec_btn"
                    >
                      <svg
                        class="Training_data_bottom_container_inner_box_right_sec_btn_play"
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        (click)="toggleVideo(i)"
                      >
                        <path
                          class="play-button"
                          d="M32 0C14.3271 0 0 14.3269 0 32C0 49.6731 14.3271 64 32 64C49.6729 64 64 49.6731 64 32C64 14.3269 49.6729 0 32 0ZM40.9232 32.7877L29.4032 39.7874C29.1701 39.9289 28.9051 40 28.64 40C28.3999 40 28.1594 39.9419 27.9418 39.8243C27.484 39.5776 27.2 39.1093 27.2 38.6001V24.6006C27.2 24.0914 27.484 23.6231 27.9418 23.3763C28.3995 23.1282 28.9592 23.1432 29.4032 23.4133L40.9232 30.413C41.344 30.6694 41.6 31.1178 41.6 31.6003C41.6 32.0829 41.344 32.5314 40.9232 32.7877Z"
                          fill="#0032A0"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="Training_data_bottom_container_inner_box_left">
                  <div
                    class="Training_data_bottom_container_inner_box_left_content text_align-justify"
                  >
                    <p class="text_black_12">{{ video.title }}</p>
                    <div
                      [ngClass]="{ text_lines_8: hasLongDescription(video) && !video.showMore, 'p-top-16': true }"
                      [innerHtml]="video.description"
                    ></div>
                  </div>
                  <div class="cursor-pointer p-top-10" *ngIf="hasLongDescription(video)">
                    <span class="text_blue_14" (click)="toggleShowMore(video)">{{
                      video.showMore
                        ? "Read Less"
                        : "Read More"
                    }}</span>
                  </div>
                  <div *ngIf="video.web_link" class="p-top-12">
                    <button
                      type="button"
                      class="rounded-pill text_white_1 button_blue_7"
                      (click)="openLink(video.web_link)"
                    >
                      <span class="button_blue_1_text"> Weblink</span>
                      <img
                        class="button_blue_1_text_icon"
                        src="../../../assets/icons/arrow-right.png"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div
                *ngIf="i % 2 !== 0"
                class="Training_data_bottom_container_inner_box"
              >
                <div class="Training_data_bottom_container_inner_box_left">
                  <div
                    class="Training_data_bottom_container_inner_box_left_content text_align-justify"
                  >
                    <p class="text_black_12">{{ video.title }}</p>
                    <div
                      [ngClass]="{ text_lines_8: hasLongDescription(video) && !video.showMore, 'p-top-16': true }"
                      [innerHtml]="video.description"
                    ></div>
                  </div>
                  <div class="cursor-pointer p-top-10" *ngIf="hasLongDescription(video)">
                    <span class="text_blue_14" (click)="toggleShowMore(video)">{{
                      video.showMore
                        ? "Read Less"
                        : "Read More"
                    }}</span>
                  </div>
                  <div *ngIf="video.web_link" class="p-top-12">
                    <button
                      type="button"
                      class="rounded-pill text_white_1 button_blue_7"
                      (click)="openLink(video.web_link)"
                    >
                      <span class="button_blue_1_text"> Weblink</span>
                      <img
                        class="button_blue_1_text_icon"
                        src="../../../assets/icons/arrow-right.png"
                      />
                    </button>
                  </div>
                </div>
                <div class="Training_data_bottom_container_inner_box_right">
                  <div
                    class="Training_data_bottom_container_inner_box_right_sec"
                  >
                    <div
                      class="Training_data_bottom_container_inner_box_right_sec_btn1"
                    >
                      <svg
                        class="Training_data_bottom_container_inner_box_right_sec_btn1_play"
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        (click)="toggleVideo(i)"
                      >
                        <path
                          class="play-button"
                          d="M32 0C14.3271 0 0 14.3269 0 32C0 49.6731 14.3271 64 32 64C49.6729 64 64 49.6731 64 32C64 14.3269 49.6729 0 32 0ZM40.9232 32.7877L29.4032 39.7874C29.1701 39.9289 28.9051 40 28.64 40C28.3999 40 28.1594 39.9419 27.9418 39.8243C27.484 39.5776 27.2 39.1093 27.2 38.6001V24.6006C27.2 24.0914 27.484 23.6231 27.9418 23.3763C28.3995 23.1282 28.9592 23.1432 29.4032 23.4133L40.9232 30.413C41.344 30.6694 41.6 31.1178 41.6 31.6003C41.6 32.0829 41.344 32.5314 40.9232 32.7877Z"
                          fill="#0032A0"
                        />
                      </svg>
                    </div>
                    <div
                      class="Training_data_bottom_container_inner_box_right_sec_video border-radius-26"
                    >
                      <video
                        class="Training_data_bottom_container_inner_box_right_sec_video_link"
                        width="100%"
                        height="100%"
                        [id]="'video-' + i"
                        [poster]="videosThumbnailUrl + video.thumbnail"
                        [src]="videoBaseUrl + video.video"
                      >
                      </video>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dispaly_2">
            <div class="Training_data_bottom_container_inner">
              <div class="Training_data_bottom_container_inner_box bg_1">
                <div class="Training_data_bottom_container_inner_box_right">
                  <div
                    class="Training_data_bottom_container_inner_box_right_sec"
                  >
                    <div
                      class="Training_data_bottom_container_inner_box_right_sec_video border-radius-26"
                    >
                      <video
                        class="Training_data_bottom_container_inner_box_right_sec_video_link"
                        width="100%"
                        height="100%"
                        [id]="'video-' + i"
                        [poster]="videosThumbnailUrl + video.thumbnail"
                        [src]="videoBaseUrl + video.video"
                      >
                      </video>
                    </div>
                    <div
                      class="Training_data_bottom_container_inner_box_right_sec_btn"
                    >
                      <svg
                        class="Training_data_bottom_container_inner_box_right_sec_btn_play"
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        (click)="toggleVideo(i)"
                      >
                        <path
                          class="play-button"
                          d="M32 0C14.3271 0 0 14.3269 0 32C0 49.6731 14.3271 64 32 64C49.6729 64 64 49.6731 64 32C64 14.3269 49.6729 0 32 0ZM40.9232 32.7877L29.4032 39.7874C29.1701 39.9289 28.9051 40 28.64 40C28.3999 40 28.1594 39.9419 27.9418 39.8243C27.484 39.5776 27.2 39.1093 27.2 38.6001V24.6006C27.2 24.0914 27.484 23.6231 27.9418 23.3763C28.3995 23.1282 28.9592 23.1432 29.4032 23.4133L40.9232 30.413C41.344 30.6694 41.6 31.1178 41.6 31.6003C41.6 32.0829 41.344 32.5314 40.9232 32.7877Z"
                          fill="#0032A0"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="Training_data_bottom_container_inner_box_left">
                  <div
                    class="Training_data_bottom_container_inner_box_left_content"
                  >
                    <p class="text_black_12">{{ video.title }}</p>
                    <div
                      [ngClass]="{ text_lines_8: hasLongDescription(video) && !video.showMore, 'p-top-16': true }"
                      [innerHtml]="video.description"
                    ></div>
                  </div>
                  <div class="cursor-pointer p-top-10" *ngIf="hasLongDescription(video)">
                    <span class="text_blue_14" (click)="toggleShowMore(video)">{{
                      video.showMore
                        ? "Read Less"
                        : "Read More"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
